module.exports = __webpack_public_path__ + "static/media/no-found-conversation.18c043dc.svg";